export default "__VITE_ASSET__CY9JytKC__"